import { GridFilterItem } from '@mui/x-data-grid-pro';

import { HttpMethod, httpClient } from './http-client';
import { QueryOptionsType } from '../@types/queryOptions.type';
import { SKUDataType, SKUConfigListResponse, SKUNameUniqueCheckType } from '../@types/sku.type';

export interface SKUMatchCheckResponse {
  isMatching: boolean;
}

export const getAllSKUConfigs = (queryOptions: QueryOptionsType): Promise<SKUConfigListResponse> => {
  const { filterModel, page, pageSize, sortModel } = queryOptions;
  let url = `/skuconfig?page=${page + 1}&limit=${pageSize}`;

  if (sortModel && sortModel[0] && sortModel[0].field) {
    url += `&order_by=${sortModel[0].field}&order_direction=${sortModel[0].sort}`;
  }

  filterModel?.items?.forEach((filter: GridFilterItem) => {
    const field = filter?.field;
    const operator = filter?.operator;
    const value = filter?.value ?? '';
    url += `&${field}=${operator},${value}`;
  });

  return httpClient<SKUConfigListResponse>(url, HttpMethod.Get);
};

export const getSKUConfigById = (id: number): Promise<SKUDataType> => {
  return httpClient<SKUDataType>(`/skuconfig/${id}`, HttpMethod.Get);
};

export const createSKUConfig = (skuConfig: SKUDataType): Promise<SKUDataType> => {
  return httpClient<SKUDataType>('/skuconfig', HttpMethod.Post, skuConfig);
};

export const updateSKUConfig = (id: number, skuConfig: SKUDataType): Promise<SKUDataType> => {
  return httpClient<SKUDataType>(`/skuconfig/${id}`, HttpMethod.Put, skuConfig);
};

export const getSKUConfigByName = (name: string, id: number): Promise<SKUNameUniqueCheckType> => {
  return httpClient<SKUNameUniqueCheckType>(`/checkIsSKUNameExists?name=${name}&id=${id}`, HttpMethod.Get);
};

// Check whether the IN and OUT part types of the REPLACE part action belong to a common sku
export const checkMatchingSKUConfigs = (inPartId: number, outPartId: number): Promise<SKUMatchCheckResponse> => {
  return httpClient<SKUMatchCheckResponse>(`/skuconfig/inPartId/${inPartId}/outPartId/${outPartId}`, HttpMethod.Get);
};